// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AisLsJaE_AWnIhDlnTUV {
    /* Reset button */
    border: none;
    background-color: inherit;
    background-image: none;
    box-shadow: none;
    cursor: pointer;
    line-height: inherit;
    font-family: inherit;
    width: 100%;
    text-align: center;
    font-size: 1.125rem;
    border-radius: var(--radius-pill);

    &.BPnwlkAJGnGOcwrKDwJG {
        padding: 0.75rem 2rem;
    }

    &.Za884Te7p61rWE1qt2DH {
        padding: 1rem 2rem;
    } 
    
    &.ERI3tyKE4RUw0w7OOwCu {
        padding: 1.25rem 2rem;
    }

    &.cdc4_xoyu5lt350lFjqA {
        font-weight: 600;
        color: var(--color-primary-white);
        background-color: var(--color-primary-red-100);

        &:hover {
            background-color: var(--color-primary-red-200);
        }

        &:active {
            background-color: var(--color-primary-red-300);
        }

        &[disabled] {
            opacity: 0.2;
            background-color: var(--color-primary-red-200);
        }

        &:focus-visible {
            outline: 3px solid var(--color-primary-black);
        }
      
    }

    &.pJ5lpFCDv2hmsZmokGiV {
        color: var(--color-primary-black);
        background-color: var(--color-primary-white);
        border: 1px solid var(--color-primary-black);
        font-weight: 400;

        &:hover {
            color: var(--color-primary-red-100);
            border-color: var(--color-primary-red-100);
        }

        &:active {
            color: var(--color-primary-black);
            border-color: var(--color-primary-black);
            background-color: var(--color-neutrals-gray-400);
        }

        &[disabled] {
            color: var(--color-primary-white);
            background-color: var(--color-neutrals-gray-300);
            border: none;
        }
    }

    &.fXCJkKBAfkdYBeb9dBwV {
        padding: 0;
        border-radius: initial;
        text-decoration: underline;
        background-color: transparent;
        color: var(--color-primary-black);

        &:hover {
            color: var(--color-primary-red-100);
        }

        &:active {
            color: var(--color-neutrals-gray-100);
        }

        &[disabled] {
            color: var(--color-neutrals-gray-300);
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,oBAAoB;IACpB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;;IAEjC;QACI,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;QAChB,iCAAiC;QACjC,8CAA8C;;QAE9C;YACI,8CAA8C;QAClD;;QAEA;YACI,8CAA8C;QAClD;;QAEA;YACI,YAAY;YACZ,8CAA8C;QAClD;;QAEA;YACI,6CAA6C;QACjD;;IAEJ;;IAEA;QACI,iCAAiC;QACjC,4CAA4C;QAC5C,4CAA4C;QAC5C,gBAAgB;;QAEhB;YACI,mCAAmC;YACnC,0CAA0C;QAC9C;;QAEA;YACI,iCAAiC;YACjC,wCAAwC;YACxC,gDAAgD;QACpD;;QAEA;YACI,iCAAiC;YACjC,gDAAgD;YAChD,YAAY;QAChB;IACJ;;IAEA;QACI,UAAU;QACV,sBAAsB;QACtB,0BAA0B;QAC1B,6BAA6B;QAC7B,iCAAiC;;QAEjC;YACI,mCAAmC;QACvC;;QAEA;YACI,qCAAqC;QACzC;;QAEA;YACI,qCAAqC;QACzC;IACJ;AACJ","sourcesContent":[".button {\n    /* Reset button */\n    border: none;\n    background-color: inherit;\n    background-image: none;\n    box-shadow: none;\n    cursor: pointer;\n    line-height: inherit;\n    font-family: inherit;\n    width: 100%;\n    text-align: center;\n    font-size: 1.125rem;\n    border-radius: var(--radius-pill);\n\n    &.s {\n        padding: 0.75rem 2rem;\n    }\n\n    &.m {\n        padding: 1rem 2rem;\n    } \n    \n    &.l {\n        padding: 1.25rem 2rem;\n    }\n\n    &.primary {\n        font-weight: 600;\n        color: var(--color-primary-white);\n        background-color: var(--color-primary-red-100);\n\n        &:hover {\n            background-color: var(--color-primary-red-200);\n        }\n\n        &:active {\n            background-color: var(--color-primary-red-300);\n        }\n\n        &[disabled] {\n            opacity: 0.2;\n            background-color: var(--color-primary-red-200);\n        }\n\n        &:focus-visible {\n            outline: 3px solid var(--color-primary-black);\n        }\n      \n    }\n\n    &.secondary {\n        color: var(--color-primary-black);\n        background-color: var(--color-primary-white);\n        border: 1px solid var(--color-primary-black);\n        font-weight: 400;\n\n        &:hover {\n            color: var(--color-primary-red-100);\n            border-color: var(--color-primary-red-100);\n        }\n\n        &:active {\n            color: var(--color-primary-black);\n            border-color: var(--color-primary-black);\n            background-color: var(--color-neutrals-gray-400);\n        }\n\n        &[disabled] {\n            color: var(--color-primary-white);\n            background-color: var(--color-neutrals-gray-300);\n            border: none;\n        }\n    }\n\n    &.text {\n        padding: 0;\n        border-radius: initial;\n        text-decoration: underline;\n        background-color: transparent;\n        color: var(--color-primary-black);\n\n        &:hover {\n            color: var(--color-primary-red-100);\n        }\n\n        &:active {\n            color: var(--color-neutrals-gray-100);\n        }\n\n        &[disabled] {\n            color: var(--color-neutrals-gray-300);\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `AisLsJaE_AWnIhDlnTUV`,
	"s": `BPnwlkAJGnGOcwrKDwJG`,
	"m": `Za884Te7p61rWE1qt2DH`,
	"l": `ERI3tyKE4RUw0w7OOwCu`,
	"primary": `cdc4_xoyu5lt350lFjqA`,
	"secondary": `pJ5lpFCDv2hmsZmokGiV`,
	"text": `fXCJkKBAfkdYBeb9dBwV`
};
module.exports = ___CSS_LOADER_EXPORT___;
